<template>
  <div class="container">
    <div class="fixed-cards">
      <el-card shadow="hover" class="card">
        <div slot="header" class="clearfix">
          <span>商户报单信息:</span>
        </div>
        <div class="card-content">
          <el-row>
            <el-col :span="8"><strong>客户姓名:</strong> {{ info.customName }}</el-col>
            <el-col :span="8"><strong>客户手机号:</strong> {{ info.customMobile }}</el-col>
            <el-col :span="8"><strong>客户地址:</strong> {{ info.customAddress }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="8"><strong>(提货)前仓名称:</strong> {{ info.warehouseName }}</el-col>
            <el-col :span="8"><strong>(提货)前仓电话:</strong> {{ info.warehouseMobile }}</el-col>
            <el-col :span="8"><strong>(提货)前仓地址:</strong> {{ info.address }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="8"><strong>提货状态:</strong>
              <el-tag v-if="info.status == 'INSTALLED'" type="info">已安装</el-tag>
              <el-tag v-if="info.status == 'WAIT_FOR_DELIVERY'" type="warning">待提货</el-tag>
              <el-tag v-if="info.status == 'WAIT_FOR_ASSIGN'" type="success">待指派</el-tag>
              <el-tag v-if="info.status == 'WAIT_INSTALL' && info.type == 'PURE_WATER'" type="warning">待安装</el-tag>
              <el-tag v-if="info.status == 'PARTIAL_INSTALLATION' && info.type == 'PURE_WATER'"
                type="warning">部分安装</el-tag>
              <el-tag v-if="info.status == 'COMPLETE' && info.type == 'PURE_WATER'" type="info">已完成</el-tag>
              <el-tag
                v-else-if="(info.status == 'WAIT_INSTALL' || info.status == 'WAIT_INSTALL_SECOND' || info.status == 'WAIT_FOR_DELIVERY_SECOND' || info.status == 'COMPLETE') && info.type == 'WATERPROOF'"
                type="info">已完成</el-tag>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </div>
    <div v-if="$route.query.type === 'WATERPROOF'">
      <!-- 首次提货商品 -->
      <div class="fixed-cards">
        <el-card shadow="hover" class="card">
          <div slot="header" class="clearfix">
            <el-row>
              <el-col :span="12" v-if="info.firstPickUpTime">
                <strong>首次提货时间:</strong> {{ formatDate(info.firstPickUpTime) }}
              </el-col>
              <el-col :span="12" v-if="selectedWarehouse.warehouseName">
                <strong>首次提货前仓:</strong> {{ selectedWarehouse.warehouseName }}
              </el-col>
            </el-row>
            <strong>首次提货商品:</strong>
          </div>
          <div class="card-content">
            <el-table :data="firstDeliveryGoods" style="width: 100%" :border="true">
              <el-table-column prop="name" label="商品名称"></el-table-column>
              <el-table-column prop="num" label="数量"></el-table-column>
            </el-table>
          </div>
        </el-card>
      </div>
      <!-- 二次提货商品 -->
      <div class="fixed-cards" v-if="info.status !== 'WAIT_FOR_ASSIGN' && info.status !== 'WAIT_FOR_DELIVERY'">
        <el-card shadow="hover" class="card">
          <div slot="header" class="clearfix">
            <el-row>
              <el-col :span="12" v-if="secondSelectedWarehouse.warehouseName">
                <strong>二次提货前仓:</strong> {{ secondSelectedWarehouse.warehouseName }}
              </el-col>
              <el-col :span="12" v-if="info.secondPickUpTime">
                <strong>二次提货时间:</strong> {{ formatDate(info.secondPickUpTime) }}
              </el-col>
            </el-row>
            <strong>二次提货商品:</strong>
          </div>
          <div class="card-content">
            <el-table :data="secondDeliveryGoods" style="width: 100%" :border="true">
              <el-table-column prop="name" label="商品名称"></el-table-column>
              <el-table-column prop="num" label="数量"></el-table-column>
            </el-table>
          </div>
        </el-card>
      </div>
      <!-- 首次提货照片 -->
      <div class="fixed-cards" v-if="info.status !== 'WAIT_FOR_ASSIGN' && info.status !== 'WAIT_FOR_DELIVERY'">
        <el-card shadow="hover" class="card">
          <div>
            <div slot="header" class="clearfix">
              <span>首次提货签名照片:</span>
            </div>
            <div class="card-content">
              <el-row>
                <el-col :span="12">
                  <strong>商户:</strong>
                  <img v-if="firstDeliveryShopPic" :src="firstDeliveryShopPic" alt="首次提货商户照片"
                    style="max-width: 100%; height: auto;" />
                  <el-button v-else type="info" size="mini" disabled>暂无照片</el-button>
                </el-col>
                <el-col :span="12">
                  <strong>工程师:</strong>
                  <img v-if="firstDeliveryConsigneePic" :src="firstDeliveryConsigneePic" alt="首次提货工程师照片"
                    style="max-width: 100%; height: auto;" />
                  <el-button v-else type="info" size="mini" disabled>暂无照片</el-button>
                </el-col>
              </el-row>
            </div>
          </div>
          <div>
            <div slot="header" class="clearfix">
              <span>二次提货签名照片:</span>
            </div>
            <div class="card-content">
              <el-row>
                <el-col :span="12">
                  <strong>商户:</strong>
                  <img v-if="secondDeliveryShopPic" :src="secondDeliveryShopPic" alt="二次提货商户照片"
                    style="max-width: 100%; height: auto;" />
                  <el-button v-else type="info" size="mini" disabled>暂无照片</el-button>
                </el-col>
                <el-col :span="12">
                  <strong>工程师:</strong>
                  <img v-if="secondDeliveryConsigneePic" :src="secondDeliveryConsigneePic" alt="二次提货工程师照片"
                    style="max-width: 100%; height: auto;" />
                  <el-button v-else type="info" size="mini" disabled>暂无照片</el-button>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <div class="fixed-cards" v-else>
      <el-card shadow="hover" class="card">
        <div slot="header" class="clearfix">
          <span>商品列表:</span>
        </div>
        <div class="card-content">
          <el-table :data="selectedGoods" style="width: 100%" border>
            <el-table-column prop="name" label="商品名称">
            </el-table-column>
            <el-table-column prop="num" label="数量">
            </el-table-column>
            <el-table-column label="操作" align="center" v-if="$route.query.type === 'PURE_WATER'">
              <template slot-scope="scope">
                <div v-if="scope.row.serviceOrderId && scope.row.serviceOrderId.length > 1">
                  <el-button v-for="(id, index) in scope.row.serviceOrderId" :key="index" :disabled="!id" type="success"
                    icon="el-icon-view" @click="viewWorkOrder({ serviceOrderId: id })" style="margin-top: 10px;">
                    工单{{ index + 1 }}
                  </el-button>
                </div>
                <div v-else>
                  <el-button :disabled="!scope.row.serviceOrderId" type="success" icon="el-icon-view"
                    @click="viewWorkOrder(scope.row)" style="margin-top: 10px;">
                    工单
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
      <!-- 提货照片 -->
      <div class="fixed-cards">
        <el-card shadow="hover" class="card">
          <div slot="header" class="clearfix">
            <span>提货照片:</span>
          </div>
          <div class="card-content">
            <viewer :images="info.consigneeSignPic" style="display: flex;">
              <div v-for="(pic, index) in info.consigneeSignPic" :key="index">
                <img :src="pic" alt="提货照片" style="max-width: 80px; height: 80px;margin-right: 10px;" />
              </div>
            </viewer>
          </div>
        </el-card>
      </div>
    </div>
    <!-- 提交和返回按钮 -->
    <div class="fixed-cards">
      <div class="card-content" style="text-align: center;">
        <el-button type="danger" size="small" @click="goBack" icon="el-icon-circle-close-outline">返回</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { getEliveryOrderV4, getEliveryOrder } from "@/api/work/eliveryOrder";
import { findPureWaterGoodsByRootDepartId } from "@/api/salesCloud/goodsQr";
import { resolveUrlPath } from "@/util/util";
export default {
  data() {
    return {
      goodsList: [], // 商品列表
      selectedGoods: [], // 用户选择的商品
      type: null, // 订单类型
      info: {
        installTime: null,
        firstDeliveryGoods: [], // 首次提货商品
        secondDeliveryGoods: [], // 二次提货商品
      }, // 表单数据
      isFormReadOnly: true, // 整个表单是否只读
      firstDeliveryGoods: [], // 首次提货商品
      secondDeliveryGoods: [], // 二次提货商品
      firstDeliveryConsigneePic: '', // 首次提货工程师照片
      secondDeliveryConsigneePic: '', // 二次提货工程师照片
      firstDeliveryShopPic: '', // 首次提货商户照片
      secondDeliveryShopPic: '', // 二次提货商户照片
      selectedWarehouse: '', // 首次提货仓库
      secondSelectedWarehouse: '' // 二次提货仓库
    };
  },
  created() {
    const id = this.$route.query.id;
    this.type = this.$route.query.type;
    if (id) {
      if (this.$route.query.type === 'WATERPROOF') {
        getEliveryOrderV4(id, this.type).then(res => {
          if (res.code === "200") {
            const data = JSON.parse(res.data).rows[0];
            this.info = data;
            if (data.list && data.list.length > 0&&data.businessId) {
              this.findPureWaterGoodsByRootDepartId(data.list);
            } else {
              // 兼容老防水订单类型
              if(data.businessId==null||data.businessId==''||!data.businessId){
              getEliveryOrder(id, this.type).then(res => {
                if (res.code === "200") {
                  const data = JSON.parse(res.data).rows[0];
                  this.info = data;
                  let selectedGoods = data.list;
                  // 分类商品列表
                  this.firstDeliveryGoods = selectedGoods.map(item => ({
                    goodsId: item.goodsId,
                    num: item.num,
                    declarationId: item.declarationId,
                    name: item.goodsName || "",
                    frequency: item.frequency
                  })).filter(item => item.frequency === 1);
                  this.secondDeliveryGoods = selectedGoods.map(item => ({
                    goodsId: item.goodsId,
                    num: item.num,
                    declarationId: item.declarationId,
                    name: item.goodsName || "",
                    frequency: item.frequency
                  })).filter(item => item.frequency === 2);
                  let selectedWarehouse = selectedGoods.filter(
                    (item) => item.frequency == 1 && item.warehouseId
                  );
                  let secondSelectedWarehouse = selectedGoods.filter(
                    (item) => item.frequency == 2 && item.warehouseId
                  );
                  this.selectedWarehouse = selectedWarehouse.length > 0 ? selectedWarehouse[0] : '';
                  this.secondSelectedWarehouse = secondSelectedWarehouse.length > 0 ? secondSelectedWarehouse[0] : '';
                }
              })
              }
            }
            if (this.$route.query.type === 'WATERPROOF') {
              // 提取首次和二次提货照片
              const shopPics = data.shopSignPic ? data.shopSignPic.split(',') : [];
              const consigneePics = data.consigneeSignPic ? data.consigneeSignPic.split(',') : [];
              this.firstDeliveryShopPic = shopPics[0] ? shopPics[0] : '';
              this.secondDeliveryShopPic = shopPics[1] ? shopPics[1] : '';
              this.firstDeliveryConsigneePic = consigneePics[0] ? consigneePics[0] : '';
              this.secondDeliveryConsigneePic = consigneePics[1] ? consigneePics[1] : '';
            } else {
              // 提取商户签名照片
              const consigneePics = data.consigneeSignPic ? data.consigneeSignPic.split(',') : [];
              this.info.consigneeSignPic = consigneePics;
            }
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error"
            });
          }
        });
      } else {
        getEliveryOrder(id, this.type).then(res => {
          if (res.code === "200") {
            const data = JSON.parse(res.data).rows[0];
            this.info = data;
            if (this.$route.query.type === 'HANG_CEILING') {
              this.selectedGoods = data.list.map(item => ({
                goodsId: item.goodsId,
                num: item.num,
                serviceOrderId: item.serviceOrderId ? item.serviceOrderId.split(',') : item.serviceOrderId,
                declarationId: item.declarationId,
                name: item.goodsName || ""
              }));
              // 提取商户签名照片
              const consigneePics = data.consigneeSignPic ? data.consigneeSignPic.split(',') : [];
              this.info.consigneeSignPic = consigneePics;
            } else {
              this.findPureWaterGoodsByRootDepartId(data.list);
              let selectedGoods = data.list;
              // 初始化已选择的商品
              this.selectedGoods = selectedGoods.map(item => ({
                goodsId: item.goodsId,
                num: item.num,
                serviceOrderId: item.serviceOrderId ? item.serviceOrderId.split(',') : item.serviceOrderId,
                declarationId: item.declarationId,
                name: item.goodsName || "",
              }));
              // 提取商户签名照片
              const consigneePics = data.consigneeSignPic ? data.consigneeSignPic.split(',') : [];
              this.info.consigneeSignPic = consigneePics;
            }
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error"
            });
          }
        });
      }
    }
  },
  methods: {
    // 处理安装时间变更
    handleInstallTimeChange(value) {
      if (value) {
        const timestamp = new Date(value).getTime(); // 将日期转换为时间戳
        this.info.installTime = timestamp;
      } else {
        this.info.installTime = null; // 如果没有选择时间，则设置为null
      }
    },
    // 获取商品列表
    findPureWaterGoodsByRootDepartId(selectedGoods) {
      findPureWaterGoodsByRootDepartId(this.type).then(res => {
        if (res.code === "200") {
          let data = JSON.parse(res.data);
          if (data) {
            this.goodsList = data;
            // 初始化已选择的商品
            this.selectedGoods = selectedGoods.map(item => ({
              goodsId: item.goodsId,
              num: item.num,
              serviceOrderId: item.serviceOrderId ? item.serviceOrderId.split(',') : item.serviceOrderId,
              // serviceOrderId: item.serviceOrderId,
              declarationId: item.declarationId,
              name: this.goodsList.find(g => g.id === item.goodsId) ? this.goodsList.find(g => g.id === item.goodsId).name : item.goodsName || "",
            }));
            if (this.$route.query.type === 'WATERPROOF') {
              // 分类商品列表
              this.firstDeliveryGoods = selectedGoods.map(item => ({
                goodsId: item.goodsId,
                num: item.num,
                declarationId: item.declarationId,
                name: this.goodsList.find(g => g.id === item.goodsId) ? this.goodsList.find(g => g.id === item.goodsId).name : item.goodsName || "",
                frequency: item.frequency
              })).filter(item => item.frequency === 1);
              this.secondDeliveryGoods = selectedGoods.map(item => ({
                goodsId: item.goodsId,
                num: item.num,
                declarationId: item.declarationId,
                name: this.goodsList.find(g => g.id === item.goodsId) ? this.goodsList.find(g => g.id === item.goodsId).name : item.goodsName || "",
                frequency: item.frequency
              })).filter(item => item.frequency === 2);
              let selectedWarehouse = selectedGoods.filter(
                (item) => item.frequency == 1 && item.warehouseId
              );
              let secondSelectedWarehouse = selectedGoods.filter(
                (item) => item.frequency == 2 && item.warehouseId
              );
              this.selectedWarehouse = selectedWarehouse.length > 0 ? selectedWarehouse[0] : '';
              this.secondSelectedWarehouse = secondSelectedWarehouse.length > 0 ? secondSelectedWarehouse[0] : '';
            }
          } else {
            this.goodsList = [];
          }
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    },
    viewWorkOrder(row) {
      let obj = {
        label: "查看工单",
        value: "/work/waterProject/engineer/engineerDetails",
        id: row.serviceOrderId
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: { GoodsId: obj.id }
      });
    },
    // 返回上一步
    goBack() {
      let item = {
        close: true,
        label: "编辑商户报单",
        value: "/work/waterProject/merchants/edit"
      };
      this.$store.commit("DEL_TAG", item);
      this.$router.go(-1);
    },
    formatDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
    }
  }
};
</script>
<style scoped>
.container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  min-height: 80%;
  box-sizing: border-box;
  font-family: fangsong;
  font-size: large;
}
.fixed-cards {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}
.card {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.card-content {
  padding: 20px;
}
.card-content img {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 5px;
  display: block;
  width: 200px;
  margin: 0 auto;
}
/* 确保表格的字体与其他部分一致 */
.el-table {
  font-family: fangsong;
  font-weight: bold;
  font-size: large;
}
.el-table th,
.el-table td {
  font-family: fangsong;
  font-size: large;
}
.el-table th {
  font-family: fangsong;
  font-size: large;
}
</style>
